import expatEnPagesData from './expatEnPages.json';

export const expatEnPages = expatEnPagesData;

export function getExpatEnPageBySlug(slug) {
  return expatEnPages.find((page) => page.slug === slug);
}
